import * as React from 'react';
import { Query } from 'react-apollo';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

import ConsumerBffCourseContext from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import ConsumerCoursePageQuery from 'bundles/unified-description-page-common/queries/bff/ConsumerCoursePageQuery.graphql';
import type {
  ConsumerCoursePageQuery as ConsumerCoursePageQueryType,
  ConsumerCoursePageQueryVariables,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';

type PropsToComponent = {
  slug: string;
  specializationSlug?: string;
  children: React.ReactNode;
};

const ConsumerBffCourseDataProvider = ({ slug, specializationSlug, children }: PropsToComponent) => {
  return (
    <Query<ConsumerCoursePageQueryType, ConsumerCoursePageQueryVariables>
      query={ConsumerCoursePageQuery}
      variables={{ slug, specializationSlug }}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {({ data, loading, error }) => {
        const coursePage = data?.DescriptionPage?.queryCoursePage;

        return (
          <ConsumerBffCourseContext.Provider value={{ coursePage, isCourseDataLoading: loading, error }}>
            {children}
          </ConsumerBffCourseContext.Provider>
        );
      }}
    </Query>
  );
};

export default compose<PropsToComponent, {}>(
  connectToRouter((router) => ({
    slug: router.params.productSlug,
    specializationSlug: router.location.query?.specialization,
  }))
)(ConsumerBffCourseDataProvider);
